/**
 * 自定义过滤器集合
 * @creater liux
 * @Email   liuxing@autobio.com.cn
 * @Date    2019年8月8日 10:00:00
 */

 //时间格式化  支持 时间类型 和 时间字符串  格式化
const formatDate = (date, fmt = 'yyyy-MM-dd hh:mm:ss') => {
  if (!date) return '';
  if (typeof (date) == "string") {
    if (/^\/Date\(.*\)\/$/.test(date)) {
      date = new Date(parseInt(date.replace("/Date(", "").replace(")/", ""), 10));
    } else {
      date = new Date(date.replace(/-/g, '/'));
    }
  }
  var o = {
    "M+": date.getMonth() + 1,                 //月份
    "d+": date.getDate(),                    //日
    "h+": date.getHours(),                   //小时
    "m+": date.getMinutes(),                 //分
    "s+": date.getSeconds(),                 //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds()             //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

export default {
  formatDate
}